import React, { useRef, useState, useEffect } from "react";
import "./IndiaSec2.css";
import "../../../Home/PackagesSection/PackagesSection.css";
import { Card } from "react-bootstrap";
import { IoIosArrowRoundForward } from "react-icons/io";
import { findIndex, map } from "lodash";
import { HiArrowLongLeft, HiArrowLongRight } from "react-icons/hi2";
import { FaStar } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getDestinationCards,
  getPackagesByCountry,
} from "../../../../API/home";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const sliderimg = {
  india: {
    mapImg: "/assets/maps/delhi-air.png",
    cards: [
      { id: 1, img: "/assets/slider/munnar.jpg", title: "Munnar", rate: 4.5 },
      {
        id: 2,
        img: "/assets/slider/thekkady.jpg",
        title: "Thekkady",
        rate: 4.5,
      },
      {
        id: 1,
        img: "/assets/slider/alleppey.jpg",
        title: "Alleppey",
        rate: 4.5,
      },
    ],
  },
  kenya: {
    mapImg: "/assets/maps/kenya-air.png",
    cards: [
      {
        id: 1,
        img: "/assets/slider/masai.jpg",
        title: "Masai Mara",
        rate: 4.2,
      },
      { id: 2, img: "/assets/slider/nairobi.jpg", title: "Nairobi", rate: 4.2 },
    ],
  },
  southafrica: {
    mapImg: "/assets/maps/south-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/4.%20South%20Africa/1.%20Cape%20Town%20&%20table%20mountain.webp",
        title: "Cape Town",
        rate: 4.7,
      },
      {
        id: 2,
        img: "/assets/slider/kruger.jpeg",
        title: "Kruger Park",
        rate: 4.7,
      },
    ],
  },
  tanzania: {
    mapImg: "/assets/maps/tanzania-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Destination%20images/Tanzania.webp",
        title: "Serengeti",
        rate: 4.6,
      },
      {
        id: 2,
        img: "/assets/slider/ngorongoro.jpg",
        title: "Ngorongoro ",
        rate: 4.6,
      },
    ],
  },
  uae: {
    mapImg: "/assets/maps/uae-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/Destination%20images/Uae.webp",
        title: "Dubai",
        rate: 4.5,
      },
      {
        id: 2,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Dubai%20Top%20Places/Dubai%20Top%20Places/Abu%20dhabi.webp",
        title: "Abu Dhabi",
        rate: 4.5,
      },
    ],
  },
  uganda: {
    mapImg: "/assets/maps/uganda-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Uganda%20Top%20places/Uganda%20Top%20places/Kabale.webp",
        title: "Kibale",
        rate: 4.8,
      },
      {
        id: 2,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Uganda%20Top%20places/Uganda%20Top%20places/Kampala.webp",
        title: "Kampala",
        rate: 4.8,
      },
    ],
  },
  zambia: {
    mapImg: "/assets/maps/zambia-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/8.%20Zambia%20Images/2.%20SOUTH%20LUANGWA%20NATIONAL%20PARK.webp",
        title: "South Luangwa",
        rate: 4.6,
      },
      {
        id: 2,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/8.%20Zambia%20Images/1.%20Victoria%20Falls.webp",
        title: "Victoria Falls",
        rate: 4.6,
      },
    ],
  },
  zimbabwe: {
    mapImg: "/assets/maps/zimbabwe-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/6.%20Zimbabwe%20Images/1.%20Victoria%20falls.webp",
        title: "Victoria Falls",
        rate: 4.9,
      },
      {
        id: 2,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/DMC%20New%20Images/6.%20Zimbabwe%20Images/2.%20Hwange%20national%20park.webp",
        title: "Hwange Park",
        rate: 4.9,
      },
    ],
  },
  qatar: {
    mapImg: "/assets/maps/qatar-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/doha%20corniche.webp",
        title: "Doha",
        rate: 4.6,
      },
      {
        id: 2,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/qatar%20Top%20places/qatar%20Top%20places/Aspire%20Zone%20(Doha%20Sports%20City).webp",
        title: "Doha Sports City",
        rate: 4.6,
      },
    ],
  },
  malaysia: {
    mapImg: "/assets/maps/malaysia-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Kuala%20Lumpur.webp",
        title: "Kuala Lumpur",
        rate: 4.7,
      },
      {
        id: 2,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Malaysia%20top%20places/Malaysia%20top%20places/Langkawi.webp",
        title: "Langkawi",
        rate: 4.7,
      },
    ],
  },
  singapore: {
    mapImg: "/assets/maps/singapore-air.png",
    cards: [
      {
        id: 1,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Marina%20Bay.webp",
        title: "Marina Bay",
        rate: 4.8,
      },
      {
        id: 2,
        img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Singapore%20top%20places/Singapore%20top%20places/Sentosa%20Island.webp",
        title: "Sentosa",
        rate: 4.8,
      },
    ],
  },
};

const countrySliderMap = {
  IN: "india",
  KE: "kenya",
  ZA: "southafrica",
  TZ: "tanzania",
  AE: "uae",
  UG: "uganda",
  ZM: "zambia",
  ZW: "zimbabwe",
  QA: "qatar",
  MY: "malaysia",
  SG: "singapore",
  RW: "rwanda",
};

export const IndiaSec2 = ({ countryCode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [slideIndex, setSlideIndex] = useState(0);
  const itineraryprevRef = useRef(null);
  const itinerarynextRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const destinationKey = countrySliderMap[countryCode];
  const data = sliderimg[destinationKey];
  const [destinationCards, setDestinationCards] = useState([]);
  const activeDestination =
    destinationCards?.[slideIndex] || destinationCards?.[0];

  useEffect(() => {
    const fetchPackages = async () => {
      const data = await getPackagesByCountry(countryCode);

      const formatted = data.map((item) => ({
        id: item.id,
        title: item.packageName,
        days: `${item.numberOfNights}N/${item.numberOfNights + 1}D`,
        location: item.cityName,
        cityName: item.cityName,
        price: `USD ${item.priceStartingFrom}`,
        image: item.profileImagePath,
        shortDescription: item.shortDescription,
        countryName: item.countryName,
        rating: item.rating,
        slug: item.slug,
      }));

      setPackages(formatted);
    };

    fetchPackages();
  }, [countryCode]);

  useEffect(() => {
    const fetchDestinations = async () => {
      const data = await getDestinationCards(countryCode);

      const formatted = data.map((item) => ({
        id: item.id,
        title: item.packageName,
        shortDescription: item.shortDescription,
        rating: item.rating,
        images: item.images || [],
      }));

      setDestinationCards(formatted);
    };

    fetchDestinations();
  }, [countryCode]);

  const stopWords = [
    "with",
    "from",
    "this",
    "that",
    "your",
    "have",
    "pick",
    "drop",
    "will",
    "then",
    "there",
    "their",
    "upon",
    "into",
    "onto",
    "over",
    "under",
    "after",
    "before",
    "station",
    "proceed",
    "and",
    "the",
    "for",
    "are",
    "but",
    "not",
    "all",
    "you",
    "our",
    "his",
    "her",
    "its",
    "they",
    "them",
    "takes",
    "day",
    "night",
    "nights",
    "days",
    "through",
    "arrival",
    "departure",
    "check-in",
    "check-out",
    "stay",
    "discover",
  ];

  const generateSlug = (text) =>
    text
      ?.toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

  const getTagsFromDescription = (text) => {
    if (!text) return [];

    const words = text
      .toLowerCase()
      .replace(/[^a-zA-Z ]/g, "")
      .split(" ")
      .filter((word) => word.length > 4 && !stopWords.includes(word));

    const uniqueWords = [...new Set(words)];
    return uniqueWords.slice(0, 3);
  };

 const totalSlides =
  destinationCards?.reduce(
    (count, item) => count + (item.images?.length || 0),
    0
  ) || 0;

  const handleDetailsClick = () => {
    navigate(
      `/destination/${countryCode}/${generateSlug(activeDestination?.title)}-${activeDestination?.id}`,
    );
  };

  return (
    <div>
      <div className="customdest-itenaries standard-padding pt-0">
        <h1 className="heading IndiaSec2Title">Itineraries to Help You Plan</h1>

        <div className="customdest-sec1">
          {/* TEXT CONTENT */}
          <div className="customdest-sec1-content">
            <div>
              <h5 className="customdest-sec1-head">
                {activeDestination?.title || "Destination Title"}
              </h5>
              <div className="customdest-sec1-tags">
                {getTagsFromDescription(
                  activeDestination?.shortDescription,
                ).map((tag, i) => (
                  <span key={i} className="customdest-sec1-tag">
                    {tag}
                  </span>
                ))}
              </div>

              <p className="desc">
                {activeDestination?.shortDescription ||
                  "Explore beautiful destinations with curated experiences."}
              </p>
            </div>

            {/* DESKTOP ONLY BUTTON */}
            <div className="desktop-btn-wrapper">
              <p
                className="customdest-sec1-button2"
                onClick={handleDetailsClick}
              >
                See Details{" "}
                <IoIosArrowRoundForward fontSize={27} fontWeight={700} />
              </p>
            </div>
          </div>

          {/* SLIDER SECTION */}
          <div className="customdest-sec1-slider">
        <Swiper
  modules={[Navigation, Autoplay]}
  slidesPerView={3}
  spaceBetween={15}
  loop={true}
  breakpoints={{
    0: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
  }}
  autoplay={{
    delay: 2000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  }}
  navigation={{
    prevEl: itineraryprevRef.current,
    nextEl: itinerarynextRef.current,
  }}
  onBeforeInit={(swiper) => {
    swiper.params.navigation.prevEl = itineraryprevRef.current;
    swiper.params.navigation.nextEl = itinerarynextRef.current;
  }}
  onSlideChange={(swiper) => {
    setSlideIndex(swiper.realIndex);
  }}
>
  {destinationCards?.map((item, i) =>
    item.images?.map((img, j) => (
      <SwiperSlide key={`${i}-${j}`}>
        <Card className="customdest-sec1-card">
          <Card.Img
            className="h-100 w-100"
            src={img.url}
            style={{ objectFit: "cover" }}
          />

          <Card.ImgOverlay className="customdest-sec1-card-overlay">
            <div className="d-flex justify-content-between">
              <Card.Title className="card-title-text subheading">
                {img.altText || item.title}
              </Card.Title>
            </div>
          </Card.ImgOverlay>
        </Card>
      </SwiperSlide>
    ))
  )}
</Swiper>

            <div className="customdest-sec1-bottom">
              <div className="customdest-sec1-progress">
                <div
                  className="customdest-sec1-progress-bar"
                  style={{
                    width: `${((slideIndex + 1) / totalSlides) * 100}%`,
                  }}
                ></div>
              </div>

              <div className="customdest-sec1-navigation">
                <div ref={itineraryprevRef} className="customdest-sec1-arrows">
                  <HiArrowLongLeft />
                </div>
                <div ref={itinerarynextRef} className="customdest-sec1-arrows">
                  <HiArrowLongRight />
                </div>
              </div>
            </div>
          </div>

          {/* MOBILE ONLY BUTTON (Shows strictly below slider on mobile) */}
          <div className="mobile-btn-wrapper">
            <p className="customdest-sec1-button2" onClick={handleDetailsClick}>
              See Details{" "}
              <IoIosArrowRoundForward fontSize={27} fontWeight={700} />
            </p>
          </div>
        </div>

        <div className="customdest-sec2 ">
          <div className="customdest-sec2-mobile-slider">
            <div className="custom-prev" ref={prevRef}>
              <img src="/assets/blue-icon1.svg" alt="Prev" />
            </div>
            <div className="custom-next" ref={nextRef}>
              <img src="/assets/blue-icon2.svg" alt="Next" />
            </div>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop={true}
              pagination={{ clickable: true }}
              spaceBetween={20}
              navigation={{
                prevEl: prevRef.current,
                nextEl: nextRef.current,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1200: { slidesPerView: 4 },
                1400: { slidesPerView: 4 },
              }}
              className="customdest-swiper"
            >
              {packages?.map((d, index) => (
                <SwiperSlide key={index}>
                  <div className="India-package-card">
                    <div className="India-image-box">
                      <img
                        src={d.image}
                        alt={d.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      {d.days && <span className="days">{d.days}</span>}
                      <span className="location-pill">
                        <span className="dot">
                          <img
                            src="/assets/homepageicons/octicon_location-24.png"
                            alt=""
                            className="locationIcon"
                          />
                        </span>
                        {d.cityName}
                      </span>
                    </div>

                    <div className="card-body">
                      <h3>{d.title}</h3>
                      <div className="stars">
                        {Array.from({ length: d.rating }).map((_, i) => (
                          <FaStar key={i} />
                        ))}
                      </div>
                      <p className="desc">
                        {d.shortDescription ||
                          "Explore beautiful destinations with curated experiences."}
                      </p>
                      <div className="bottom">
                        <div>
                          <p className="small">Starts From</p>
                          <h4>{d.price || "USD 1,850"}</h4>
                          <p className="small">Net Agent Rate</p>
                        </div>
                        <button
                          onClick={() =>
                            navigate(
                              `/destination/${d.countryName}/${d.slug}-${d.id}`,
                            )
                          }
                        >
                          View Package
                        </button>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};
